import { render, staticRenderFns } from "./BookPlayer.vue?vue&type=template&id=0c8ac13a&scoped=true"
import script from "./BookPlayer.vue?vue&type=script&lang=js"
export * from "./BookPlayer.vue?vue&type=script&lang=js"
import style0 from "./BookPlayer.vue?vue&type=style&index=0&id=0c8ac13a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8ac13a",
  null
  
)

export default component.exports